<template>
    <div class="content-wrapper">
        <div class="row">
            <app-breadcrumb :page-title="sport" :directory="$t('datatables')" :icon="'grid'" class="col-6"/>
        </div>  
        <div class="mb-primary col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h5 class="mb-3 d-none">{{ $t('filters') }}</h5>
        
            <app-table :id="'sports-filter-table'" :options="options" @action="getAction"/>
        </div>
    </div>
</template>

<script>

    import * as actions from "../../../../Config/ApiUrl";
    import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
    import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

    export default {
        name: "betfair-log-filter",
        mixins: [FormMixin],
        extends: CoreLibrary,
        props: ['sport'],
        data() {
            return {
                confirmedModal: false,
                alertModal: false,
                createAlertModal: false,
                selectedRow: null,
                selectedConditions: {
                    'wdw': {},
                    'ah': {},
                    'ou': {}
                },
                options: {
                    id: 'sports-table',
                    name: this.$t('sports_filter'),
                    url: actions.BETFAIR_DATATABLE_LOG,
                    showHeader: true,
                    showCount: true,
                    showClearFilter: true,
                    enableSaveFilter: true,
                    columns: [
                        {
                            title: 'ID',
                            type: 'text',
                            key: 'id',
                        },
                        {
                            title: this.$t('sport'),
                            type: 'custom-html',
                            key: 'game',
                            modifier: (value) => {
                                if (value != null){
                                   return this.$t(value.sport.toLowerCase());
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('name'),
                            type: 'custom-html',
                            key: 'game',
                            modifier: (value) => {
                                if (value != null){
                                    return '<a href="/' + actions.BETFAIR_GAME + '/' + value.id + '/" target="_blank">' + value.name + '</a>';
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('competition'),
                            type: 'custom-html',
                            key: 'game',
                            modifier: (value) => {
                                if (value != null){
                                    return '<a class="hidden-link" href="' + window.location.href + '&leagueid=' + value.external_competition_id + '">' + value.competition + '</a>';
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('market'),
                            type: 'custom-html',
                            key: 'market_type',
                            modifier: (value) => {
                                if (value != null){
                                   return value;
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('selection'),
                            type: 'custom-html',
                            key: 'market_name',
                            modifier: (value) => {
                                if (value != null){
                                   return value;
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('last_price_traded') + '*',
                            type: 'trades-preview',
                            key: 'trades'
                        },
                        {
                            title: this.$t('added'),
                            type: 'trades-preview-price',
                            key: 'difference'
                        },
                        {
                            title: this.$t('total'),
                            type: 'custom-html',
                            key: 'new',
                            modifier: (value) => {
                                if (value != null){
                                   return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(value);
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('market_total'),
                            type: 'custom-html',
                            key: 'market_total_matched',
                            modifier: (value) => {
                                if (value != null){
                                   return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(value);
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('time'),
                            type: 'text',
                            key: 'created_at',
                    
                        },
                    ],
                    actions: [
                    ],
                    filters: [
                        {
                            "title": this.$t('sport'),
                            "type": "checkbox",
                            "key": "sport",
                            "option": [
                                {id: 'football', value: 'Football'},
                                {id: 'basketball', value: 'Basketball'},
                                {id: 'tennis', value: 'Tennis'},
                            ],
                        },
                        {
                            "title": this.$t('added_amount'),
                            "type": "editable-range-filter",
                            "key": "amount",
                            "maxTitle": "Max EUR",
                            "minTitle": "Min EUR",
                            "sign": "€",
                            "maxRange": 500000,
                            "minRange": 0
                        },
                        {
                            "title": this.$t('total_amount'),
                            "type": "editable-range-filter",
                            "key": "total",
                            "maxTitle": "Max EUR",
                            "minTitle": "Min EUR",
                            "sign": "€",
                            "maxRange": 5000000,
                            "minRange": 0
                        },
                        {
                            "title": this.$t('market_total_amount'),
                            "type": "editable-range-filter",
                            "key": "market_total",
                            "maxTitle": "Max EUR",
                            "minTitle": "Min EUR",
                            "sign": "€",
                            "maxRange": 5000000,
                            "minRange": 0
                        },
                    ],
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 50,
                    showAction: true,
                    actionType: "default",
                    autoRefresh: true,
                    autoRefreshSpeed: 2000,
                    paginationOptions: [10, 25, 50, 100, 200],
                },
            }
        },
        created() {
            this.searchAndSelectFilterOptions();
        },
        methods: {
            getAction(row, actionObj, active) {
            },
            closeModal() {
                this.createAlertModal = false;
                this.confirmedModal = false;
                this.alertModal = false;
            },
            searchAndSelectFilterOptions() {
                /*const params = new Proxy(new URLSearchParams(window.location.search), {
                    get: (searchParams, prop) => searchParams.get(prop),
                });
                this.axiosGet(actions.BETFAIR_DATATABLE_LOG_SEARCH, {
                    params: {
                        sport: this.sport == 'all' ? null : this.sport
                    }
                }).then(response => {
                    this.options.filters.push({
                        "title": this.$t('search_leagues'),
                        "type": "drop-down-filter",
                        "key": "league",
                        "option": [] = response.data.map(league => {
                            return {
                                id: league.id,
                                value: league.name
                            }
                        })
                    })
                });*/
            }
        }
    }
</script>
<style>
.bf-container {
    display: flex;
    text-align: center;
    color: #ececec;
}

.bf-container > div {
    flex: 1;
}

.back-1, .back-2, .back-3, .lay-1, .lay-2, .lay-3 {
    min-width: 80px;
}

.bf-container .price {
    font-weight: 600;
}

.back-1 {
    background: #559d63;
}

.back-1.empty {
    background: #3e724f;
}

.back-2 {
    background: #4b8558;
}

.back-2.empty {
    background: #39644a;
}

.back-3 {
    background: #416d4e;
}

.back-3.empty {
    background: #355645;
}

.lay-1 {
    background: #9d5555;
}

.lay-1.empty {
    background: #704045;
}

.lay-2 {
    background: #854b4b;
}

.lay-2.empty {
    background: #623b40;
}

.lay-3 {
    background: #6d4141;
}

.lay-3.empty {
    background: #54373c;
}

</style>